import { render, staticRenderFns } from "./DataPointDetails.vue?vue&type=template&id=8dcb015c&scoped=true&"
import script from "./DataPointDetails.vue?vue&type=script&lang=js&"
export * from "./DataPointDetails.vue?vue&type=script&lang=js&"
import style0 from "./DataPointDetails.vue?vue&type=style&index=0&id=8dcb015c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcb015c",
  null
  
)

export default component.exports